import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserItem } from './user.model';



@Injectable()
export class UserService {
    /**
     * Constructor of address service
     *
     * @param http - The http client
     */
    constructor(private http: HttpClient) {}

    /**
     * Returns a list of addresses
     *
     * @returns - An observable that emits the response
     */
    public getUser(email: string): Observable<UserItem> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/getUser.php?email=${email}&${sessionStorage.getItem('session')}`) as Observable<
          UserItem
        >;
    }

}
